export default "__VITE_ASSET__6bp_5It$EfTQ8f$omStdjw__"